import { Cart } from '@msdyn365-commerce/retail-proxy';

export const getRawCartSubtotalAmount = (cart?: Cart) => {
    let rawSubtotalAmount = 0;
    if (cart?.CartLines && cart?.CartLines.length) {
        for (const line of cart?.CartLines) {
            rawSubtotalAmount += line.ExtendedPrice || 0;
        }
    }
    rawSubtotalAmount -= getDiscount(cart);
    return rawSubtotalAmount.toFixed(2);
};

export const getDiscount = (cart?: Cart) => {
    let discountAmount = 0;
    if (cart?.Coupons && cart?.Coupons.length && cart.CartLines && cart.CartLines.length) {
        for (const coupon of cart.Coupons) {
            for (const line of cart.CartLines) {
                if (line.DiscountLines) {
                    for (const discountLine of line.DiscountLines) {
                        if (discountLine.DiscountCode === coupon.Code) {
                            discountAmount += discountLine.EffectiveAmount!;
                        }
                    }
                }
            }
        }
    }
    return discountAmount * -1;
};

export const getDiscountForCoupon = (code: string, cart?: Cart) => {
    let discountAmount = 0;
    if (cart?.CartLines && cart.CartLines.length) {
        for (const line of cart.CartLines) {
            if (line.DiscountLines) {
                for (const discountLine of line.DiscountLines) {
                    if (discountLine.DiscountCode === code) {
                        discountAmount += discountLine.EffectiveAmount!;
                    }
                }
            }
        }
    }

    return discountAmount * -1;
};
